import React from 'react'
import {
  Location,
  LocationContainer,
  LocationBuilding,
  LocationPickup,
  LocationLogo,
  LocationTime,
} from '../common/Location'
import currency from 'currency.js'
import { Action } from '@foodsby/nutrient'

const OrderInfo = ({
  orderId,
  orderPrice,
  showOrderSummary,
  toggleShowOrderSummary,
}) => {
  return (
    <div className="order-info">
      <div className="row">
        <div className="col-xs-6">Order ID: </div>
        <div className="col-xs-6">{orderId}</div>
      </div>
      <div className="row">
        <strong className="col-xs-6">Total: </strong>
        <div className="col-xs-6">
          {currency(orderPrice, { formatWithSymbol: true }).format()}
        </div>
      </div>
      <Action className="showMoreBtn" onClick={toggleShowOrderSummary}>
        {showOrderSummary ? 'Hide Details' : 'Show Details'}
      </Action>
    </div>
  )
}

const ConfirmationLocation = ({
  order,
  loading,
  showOrderSummary,
  toggleShowOrderSummary,
}) => {
  return (
    <Location>
      {order && (
        <div>
          <LocationContainer>
            <div className="row">
              <div className="col-xs-12 col-md-6 center-xs logo-container">
                <div className="row middle-xs">
                  <div className="col-xs-6 col-md-12">
                    <LocationLogo
                      logoAlt={order.storeName + ' Logo'}
                      logoLink={order.logoUrl}
                    />
                  </div>
                  <div className="col-xs-6 col-md-12">
                    <OrderInfo
                      orderId={order.orderId}
                      orderPrice={order.orderTotal}
                      showOrderSummary={showOrderSummary}
                      toggleShowOrderSummary={toggleShowOrderSummary}
                    />
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 location-info-container">
                <LocationTime
                  dateTime={order.originalDeliveryDateTime}
                  multiLine={false}
                />
                <LocationBuilding
                  address={order.address}
                  name={order.locationName}
                />
                <LocationPickup pickupInstruction={order.pickupInstructions} />
              </div>
            </div>
          </LocationContainer>
        </div>
      )}
    </Location>
  )
}

export default ConfirmationLocation
